export default {"src":"/_next/static/media/tilda-logo-weiss.86db8eea.svg","height":160,"width":623,"blurWidth":0,"blurHeight":0};